document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll<HTMLButtonElement>('[data-file-download-url]').forEach(button => {
    button.addEventListener('click', async function () {
      const url = this.dataset.fileDownloadUrl;
      if (!url) return;

      const form = this.closest('form');
      const formData = form ? new FormData(form) : new FormData();
      const warningId = this.dataset.fileDownloadWarning;

      if (warningId) {
        const warning = document.getElementById(warningId);
        if (warning) {
          warning.classList.remove('hidden');
        }
      }

      this.disabled = true;
      const spinner = document.createElement('i');
      spinner.className = 'fas fa-spinner fa-spin me-1';
      this.insertBefore(spinner, this.firstChild);

      try {
        const response = await fetch(url, {
          method: 'POST',
          body: formData
        });

        if (response.redirected) {
          window.location.href = response.url;
          return;
        }

        if (!response.ok) {
          throw new Error('Download failed');
        }

        const blob = await response.blob();
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'download';
        if (contentDisposition) {
          const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match && match[1]) {
            filename = match[1].replace(/['"]/g, '');
          }
        }

        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        a.remove();
      } catch (error) {
        console.error('Error downloading file:', error);
        alert(window.ifunds.strings.downloadError);
      } finally {
        this.disabled = false;
        spinner.remove();
      }
    });
  });
});
